<template>
    <main id="modal" class="abs">
        <div class="product-select rel">
            <div><i class="close-dialog" @click="closeDialog(list, component);"></i></div>
            <h1 class="title">Index</h1>
            <input id="position" type="number" v-model="getPosition" />
            <h1 class="title">{{ $t("configurator.product") }}</h1>
            <div v-if="product !== null" :key="product.id" v-for="product in relatedProducts" class="content-product">
                <input :id="'product_' + product.id" @click="addProduct(product, $event.target.checked);" type="checkbox" />
                <label :for="'product_' + product.id">{{ getTranslate(product.terms.name) }}</label>
            </div>
            <h1 class="title">Tester</h1>
            <div>
                <input type="checkbox" id="tester" v-model="tester" /> <label for="tester">{{ $t("configurator.messageAlert1") }}</label>
            </div>
            <div class="buttonbar">
                <button class="btn" @click="valid">OK</button>
                <!-- <button class="btn" @click="cancel">cancel</button> -->
            </div>
        </div>
    </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    props: { position: { type: Number, default: 1 } },
    data() {
        return {
            productsSelected: [],
            tester: false
        };
    },
    computed: {
        ...mapGetters("items", {
            relatedProducts: "getRelatedProducts"
        }),

        getPosition: {
            set(value) {
                this.position = parseInt(value, 10);
            },

            get() {
                return this.position;
            }
        }
    },
    created() {
        this.getRelatedProductsAction({ id: this.$route.params.id });
    },
    mounted() {},
    methods: {
        ...mapActions("items", {
            getRelatedProductsAction: "getRelatedProducts"
        }),
        closeDialog() {
            this.close();
        },
        addProduct(product, checked) {
            if (checked) {
                this.productsSelected.push(product.id);
            } else {
                // modules.splice(modules.indexOf(data), 1)
                this.productsSelected.splice(this.productsSelected.indexOf(product.id), 1);
            }
        },
        close() {
            this.$parent.displayProductSelect = false;
        },
        cancel() {
            this.close();
        },
        valid() {
            if (this.productsSelected.length === 0) {
                this.$swal({
                    title: "",
                    text: this.$t("configurator.messageAlert4"),
                    type: "warning",
                    // showCancelButton: true,
                    confirmButtonColor: "#41b4e8",
                    confirmButtonText: "OK"
                });
            } else {
                this.$parent.callbackTester(this.productsSelected, this.tester, this.position);
                this.close();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/themes";
#modal {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 30;
    margin: auto;

    .close-dialog {
        position: absolute;
        background-image: url("../../assets/croix.png");
        background-repeat: no-repeat;
        background-size: 16px;
        right: -10px;
        top: -10px;
        height: 16px;
        width: 16px;
        cursor: pointer;
    }

    .product-select {
        @extend %second-background;
        padding: 30px; //   position: absolute;
        z-index: 200;
        width: 500px;
        border-radius: 3px;
        margin: 200px auto;

        .content-product {
            white-space: nowrap;
        }
    }

    .buttonbar {
        padding-top: 20px;
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// ProductSelect.vue?38639368